import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { LoggedOutLayout } from 'containers';
import { PasswordResetForm, Card } from 'components';
import { verifySigninLink } from 'redux/modules/auth';
import localStorage from 'local-storage';
var PartnerOnboardingSigninRedirect = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    signinLinkOk: state.auth.signinLinkOk
  };
}, {
  verifySigninLink: verifySigninLink
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PartnerOnboardingSigninRedirect, _Component);

  var _super = _createSuper(PartnerOnboardingSigninRedirect);

  function PartnerOnboardingSigninRedirect() {
    _classCallCheck(this, PartnerOnboardingSigninRedirect);

    return _super.apply(this, arguments);
  }

  _createClass(PartnerOnboardingSigninRedirect, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this$props$location$ = this.props.location.query,
          secret = _this$props$location$.secret,
          verifier = _this$props$location$.verifier;
      this.props.verifySigninLink(secret, verifier).then(function (res) {
        localStorage.set('accessToken', res.data);
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.signinLinkOk === true) {
        window.location.href = '/global/partner-user-setup';
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showBg: true
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Redirecting..."
      }), /*#__PURE__*/React.createElement("div", {
        className: 'row center-xs middle-xs',
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Card, {
        className: "col-xs-12 col-sm-6 col-md-4"
      }, /*#__PURE__*/React.createElement("h1", null, "Redirecting..."), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
        style: {
          fontSize: 25
        },
        className: "fa fa-spinner fa-spin"
      })))));
    }
  }]);

  return PartnerOnboardingSigninRedirect;
}(Component), _defineProperty(_class2, "propTypes", {}), _temp)) || _class);
export { PartnerOnboardingSigninRedirect as default };